import type { CSSProperties } from 'react';

/**
 * Анимации появления сделаны на CSS-классах (`.anim-*` в app/styles), а не на
 * JS-библиотеке: у них нулевая цена в бандле и они сами отключаются по
 * `prefers-reduced-motion`. Задержку каскада задаём инлайновым стилем.
 */
export function delay(ms: number): CSSProperties {
  return { animationDelay: `${ms}ms` };
}

/** Каскад для списков: i-й элемент стартует на `step` мс позже предыдущего. */
export function stagger(index: number, step = 30, max = 300): CSSProperties {
  return { animationDelay: `${Math.min(index * step, max)}ms` };
}
